import React from 'react';
import { Dialog, DialogContent, DialogTitle, DialogActions, Button, Typography } from '../../ui/core';

const ConfirmModal = ({ open, title, message, confirmLabel, confirmColor, confirmDisabled, onConfirm, onCancel }) => {
  return (
    <Dialog open={open} onClose={onCancel} maxWidth="xs" fullWidth>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <Typography>{message}</Typography>
      </DialogContent>
      <DialogActions sx={{ padding: '16px 24px' }}>
        <Button onClick={onCancel} variant="outlined" disabled={!!confirmDisabled}>
          Cancel
        </Button>
        <Button
          onClick={onConfirm}
          variant="contained"
          color={confirmColor || 'error'}
          disabled={!!confirmDisabled}
          disableElevation
        >
          {confirmLabel}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmModal;
